import React, {Fragment, useState} from "react";
import "../../assets/css/course.css"

import Meeting_grupe_view from "./Meeting_grupe_view";
import {empty_bk} from "../../clientconfigwebapp";
import $ from "jquery";
import MenuIcon from '@mui/icons-material/Menu';
import CancelIcon from '@mui/icons-material/Cancel';

const Meeting_view = (props) => {


    const handle_Open_side_bar = () => {
        $(".side_bar_metting").removeClass("side_bar_metting_open");
        $(".side_bar_metting").addClass("side_bar_metting_open");
    }


    const handle_Close_side_bar = () => {
        $(".side_bar_metting").removeClass("side_bar_metting_open");

    }

    return (
        <Fragment>
            {

                (() => {
                    if (props.data_info_details.length == 0) {
                        return (

                            <Fragment>
                                Loading
                            </Fragment>
                        )
                    } else {


                        return (

                            <>
                                {/*<div className="box_button_side_bar_open">*/}

                                {/*    <button type={"button"} onClick={handle_Open_side_bar}>  <MenuIcon style={{"fontSize":"21px","position":"relative","top":"4px"}} /><span style={{"position":"relative","top":"-3px","right":"5px"}}>لیست جلسات</span></button>*/}
                                {/*</div>*/}


                                <div id="side_bar_metting" className="side_bar_metting">

                                    {/*<div className="box_button_side_bar_close">*/}

                                    {/*    <button type={"button"} onClick={handle_Close_side_bar}>  <CancelIcon style={{"fontSize":"21px","position":"relative","top":"4px"}} /><span style={{"position":"relative","top":"-3px","right":"5px"}}>بستن لیست جلسات</span></button>*/}
                                    {/*</div>*/}

                                    <Meeting_grupe_view id_grupe={props.id_grupe} id_fhater={props.id_fhater}
                                                        cource_id_get={props.cource_id_get}
                                                        data_lessons={props.data_lessons} page_view={props.page_view}
                                                        data_info_details={props.data_info_details}
                                                        lesson_id={props.lesson_id}  post_type={props.post_type} />
                                </div>

                            </>

                        )


                    }
                })()


            }
        </Fragment>
    )

}

export default Meeting_view;